<template>
  <fragment>
    <v-row justify="center" class="py-6">
      <v-img :src="require(`../assets/tmx-logo-h100.png`)" max-width="160px"/>
    </v-row>
    <!--v-list dense>
      <v-list-item @click="$router.push('/')">
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('mainNavBar.home') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <template v-for="(item, index) in $store.state.mainMenu.mainMenu">
        <fragment v-if="!item.children || item.children.length === 0" :key="index">
          <v-list-item :key="index" @click="item.click()">
            <v-list-item-content>
              <v-list-item-title>
                {{ $t(`${item.text}`) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </fragment>
        <fragment v-else-if="item.children && item.children.length > 0" :key="index">
          <v-list-group>
            <template v-slot:activator>
              <v-list-item-title>
                {{ $t(`${item.text}`) }}
              </v-list-item-title>
            </template>
            <v-list-item v-for="(item, index) in item.children" :key="index"
                         @click="$router.push(item.path)"
                         v-show="!(item.text === 'mainNavBar.jobOffers' && $i18n.locale !== 'hu-HU')">
              <v-list-item-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t(`${item.text}`) }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </fragment>
      </template>
    </v-list-->
  </fragment>
</template>

<script>
export default {
  name: 'storeNavSidebar',
  props: {
    //
  },
  data() {
    return {
      //
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
